import { useCurrentUser } from './api/useUsers'

/**
 * Hook to check if the current user is a system admin.
 * Reads users.is_admin (global flag for user management capabilities).
 * Distinct from per-entity business roles (contributor / approver / legalRepresentative).
 */
export function useIsAdmin() {
  const { data: currentUser, isLoading } = useCurrentUser()

  return {
    isAdmin: currentUser?.is_admin ?? false,
    isLoading,
  }
}
